var map = {
	"./audio1.png": "91c9",
	"./audio2.png": "f20f",
	"./audio3.png": "586b",
	"./audio4.png": "c26f",
	"./audio5.png": "a8f0",
	"./audio6.png": "37ea",
	"./audio7.png": "d7c7",
	"./audio8.png": "d765",
	"./doc1.png": "d2a3",
	"./doc2.png": "da79",
	"./doc3.png": "5881",
	"./doc4.png": "96a8",
	"./doc5.png": "e7c6",
	"./doc6.png": "fe4b",
	"./doc7.png": "9dff",
	"./doc8.png": "35cb",
	"./img1.png": "e130",
	"./img2.png": "3dac",
	"./img3.png": "be78",
	"./img4.png": "a3ba",
	"./img5.png": "209d",
	"./img6.png": "c145",
	"./img7.png": "2fe3",
	"./img8.png": "4cab",
	"./v1.png": "7d75",
	"./v2.png": "ae3e",
	"./v3.png": "68c6",
	"./v4.png": "c636",
	"./v5.png": "a13e",
	"./v6.png": "bd29",
	"./v7.png": "1382e",
	"./v8.png": "182c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2071";